import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import getCheckedSiteId from '../../utils/siteId.js';
import { selectionUrls, trainingHotelUrls, sportCampUrls, sportDanceUrls, sportActiveUrls, sportTennisUrls, sportRunningUrls, sportMTBUrls, sportHikingUrls, sportGolfUrls, sportCyclingUrls, sportPadelUrls, sportYogaUrls, sportsClubUrls, sportUrls, primeComfortUrls, primeSelectUrls, familyComfortUrls, familyGardenUrls, obcUrls, sunprimeUrls, sunwingUrls, cloudinaryBaseUrls } from './imageUrls.js';
import { ConceptBadge as ConceptBadge$2 } from './style.js';
import { jsx } from 'react/jsx-runtime';
import Picture from '../Picture/Picture.js';

var _excluded = ["className", "siteId", "concept", "onClick", "alt", "lazy"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var imageSizesDesktop = {
  large: 70,
  medium: 45,
  small: 25
};
var imageSizesMobile = {
  large: 50,
  medium: 30,
  small: 18
};
var getConceptSettings = function getConceptSettings() {
  var concept = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var checkedSiteId = arguments.length > 1 ? arguments[1] : undefined;
  var checkedConcept = concept ? concept.toLowerCase() : '';
  switch (checkedConcept) {
    case 'sunwing':
    case 'sunwingfamilyresorts':
      {
        return {
          altText: 'Sunwing',
          url: sunwingUrls[checkedSiteId],
          mobileUrl: sunwingUrls[checkedSiteId]
        };
      }
    case 'sunprime':
    case 'sunprimehotels':
      {
        return {
          altText: 'Sunprime',
          url: sunprimeUrls[checkedSiteId],
          mobileUrl: sunprimeUrls[checkedSiteId]
        };
      }
    case 'oceanbeachclub':
    case 'obcbysunwing':
    case 'ocean beach club':
      {
        return {
          altText: 'Ocean Beach Club',
          url: obcUrls[checkedSiteId],
          mobileUrl: obcUrls[checkedSiteId]
        };
      }
    case 'familygarden':
      {
        return {
          altText: 'Family Garden',
          url: familyGardenUrls[checkedSiteId],
          mobileUrl: familyGardenUrls[checkedSiteId],
          svgSources: true
        };
      }
    case 'familycomfort':
      {
        return {
          altText: 'Family Comfort',
          url: familyComfortUrls[checkedSiteId],
          mobileUrl: familyComfortUrls[checkedSiteId],
          desktopSize: imageSizesDesktop.small,
          mobileSize: imageSizesMobile.small
        };
      }
    case 'primeselect':
      {
        return {
          altText: 'Prime Select',
          url: primeSelectUrls[checkedSiteId],
          mobileUrl: primeSelectUrls[checkedSiteId],
          desktopSize: imageSizesDesktop.small,
          mobileSize: imageSizesMobile.small
        };
      }
    case 'primecomfort':
      {
        return {
          altText: 'Prime Comfort',
          url: primeComfortUrls[checkedSiteId],
          mobileUrl: primeComfortUrls[checkedSiteId],
          desktopSize: imageSizesDesktop.small,
          mobileSize: imageSizesMobile.small
        };
      }
    case 'sport':
      {
        return {
          altText: 'Sport',
          url: sportUrls[checkedSiteId],
          mobileUrl: sportUrls[checkedSiteId],
          desktopSize: imageSizesDesktop.large,
          mobileSize: imageSizesMobile.large
        };
      }
    case 'sportsclub':
      {
        return {
          altText: 'Sports Club',
          url: sportsClubUrls[checkedSiteId],
          mobileUrl: sportsClubUrls[checkedSiteId],
          desktopSize: imageSizesDesktop.large,
          mobileSize: imageSizesMobile.large
        };
      }
    case 'sportyoga':
      {
        return {
          altText: 'Sport Yoga',
          url: sportYogaUrls[checkedSiteId],
          mobileUrl: sportYogaUrls[checkedSiteId],
          desktopSize: imageSizesDesktop.large,
          mobileSize: imageSizesMobile.large
        };
      }
    case 'sportpadel':
      {
        return {
          altText: 'Sport Padel',
          url: sportPadelUrls[checkedSiteId],
          mobileUrl: sportPadelUrls[checkedSiteId],
          desktopSize: imageSizesDesktop.large,
          mobileSize: imageSizesMobile.large
        };
      }
    case 'sportcycling':
      {
        return {
          altText: 'Sport Cycling',
          url: sportCyclingUrls[checkedSiteId],
          mobileUrl: sportCyclingUrls[checkedSiteId],
          desktopSize: imageSizesDesktop.large,
          mobileSize: imageSizesMobile.large
        };
      }
    case 'sportgolf':
      {
        return {
          altText: 'Sport Golf',
          url: sportGolfUrls[checkedSiteId],
          mobileUrl: sportGolfUrls[checkedSiteId],
          desktopSize: imageSizesDesktop.large,
          mobileSize: imageSizesMobile.large
        };
      }
    case 'sporthiking':
      {
        return {
          altText: 'Sport Hiking',
          url: sportHikingUrls[checkedSiteId],
          mobileUrl: sportHikingUrls[checkedSiteId],
          desktopSize: imageSizesDesktop.large,
          mobileSize: imageSizesMobile.large
        };
      }
    case 'sportmtb':
      {
        return {
          altText: 'Sport MTB',
          url: sportMTBUrls[checkedSiteId],
          mobileUrl: sportMTBUrls[checkedSiteId],
          desktopSize: imageSizesDesktop.large,
          mobileSize: imageSizesMobile.large
        };
      }
    case 'sportrunning':
      {
        return {
          altText: 'Sport Running',
          url: sportRunningUrls[checkedSiteId],
          mobileUrl: sportRunningUrls[checkedSiteId],
          desktopSize: imageSizesDesktop.large,
          mobileSize: imageSizesMobile.large
        };
      }
    case 'sporttennis':
      {
        return {
          altText: 'Sport Tennis',
          url: sportTennisUrls[checkedSiteId],
          mobileUrl: sportTennisUrls[checkedSiteId],
          desktopSize: imageSizesDesktop.large,
          mobileSize: imageSizesMobile.large
        };
      }
    case 'sportactive':
      {
        return {
          altText: 'Sport Active',
          url: sportActiveUrls[checkedSiteId],
          mobileUrl: sportActiveUrls[checkedSiteId],
          desktopSize: imageSizesDesktop.large,
          mobileSize: imageSizesMobile.large
        };
      }
    case 'sportdance':
      {
        return {
          altText: 'Sport Dance',
          url: sportDanceUrls[checkedSiteId],
          mobileUrl: sportDanceUrls[checkedSiteId],
          desktopSize: imageSizesDesktop.large,
          mobileSize: imageSizesMobile.large
        };
      }
    case 'sportcamp':
      {
        return {
          altText: 'Sport Camp',
          url: sportCampUrls[checkedSiteId],
          mobileUrl: sportCampUrls[checkedSiteId],
          desktopSize: imageSizesDesktop.large,
          mobileSize: imageSizesMobile.large
        };
      }
    case 'träningshotell':
    case 'träningsresor':
    case 'treningsreiser':
    case 'training':
    case 'kuntoloma':
      {
        return {
          altText: 'Training Hotel',
          url: trainingHotelUrls[checkedSiteId],
          mobileUrl: trainingHotelUrls[checkedSiteId],
          desktopSize: imageSizesDesktop.small,
          mobileSize: imageSizesMobile.small
        };
      }
    case 'activeselection':
      return {
        altText: 'Active Selection',
        url: selectionUrls.active,
        desktopSize: 44,
        mobileSize: 44 * 0.65,
        svgSources: true
      };
    case 'adultonlyselection':
      return {
        altText: 'Adults Only Selection',
        url: selectionUrls.adultsOnly,
        desktopSize: 47,
        mobileSize: 47 * 0.65,
        svgSources: true
      };
    case 'cityfavouriteselection':
      return {
        altText: 'City Favourite Selection',
        url: selectionUrls.cityFavourite,
        desktopSize: 49,
        mobileSize: 49 * 0.65,
        svgSources: true
      };
    case 'familyselection':
      return {
        altText: 'Family Selection',
        url: selectionUrls.family,
        desktopSize: 42,
        mobileSize: 42 * 0.65,
        svgSources: true
      };
    case 'golfselection':
      return {
        altText: 'Golf Selection',
        url: selectionUrls.golf,
        desktopSize: 41,
        mobileSize: 41 * 0.65,
        svgSources: true
      };
    case 'hideawayselection':
      return {
        altText: 'Hideaway Selection',
        url: selectionUrls.hideaway,
        desktopSize: 45,
        mobileSize: 45 * 0.65,
        svgSources: true
      };
    case 'nordicfavouriteselection':
    case 'nordic selection':
    case 'nordicselection':
    case 'nordicfavourites':
    case 'nordiskafavoriter':
    case 'pohjoismaisetsuosikit':
    case 'nordiskefavoritter':
      return {
        altText: 'Nordic Favourite Selection',
        url: selectionUrls.nordicFavourite,
        desktopSize: 51,
        mobileSize: 51 * 0.65,
        svgSources: true
      };
    case 'popularselection':
      return {
        altText: 'Popular Selection',
        url: selectionUrls.popular,
        desktopSize: 43,
        mobileSize: 43 * 0.65,
        svgSources: true
      };
    case 'romanticselection':
      return {
        altText: 'Romantic Selection',
        url: selectionUrls.romantic,
        desktopSize: 45,
        mobileSize: 45 * 0.65,
        svgSources: true
      };
    case 'topselection':
    case 'topselectionfamily':
    case 'topselectionadult':
    case 'topselectionothers':
    case 'signature':
    case 'signature_t':
    case 'topselectionother':
    case 'topselectionförvuxna':
    case 'topselectionforvoksne':
    case 'topselectionaikuisille':
    case 'topselectionförfamiljer':
    case 'topselectionforfamilier':
    case 'topselectionforfamilien':
    case 'topselectionperheille':
    case 'topselectionföralla':
    case 'topselectionforalle':
    case 'topselectionkaikille':
      return {
        altText: 'Top Selection',
        url: selectionUrls.top,
        desktopSize: 39,
        mobileSize: 39 * 0.65,
        svgSources: true
      };
    case 'uniqueselection':
      return {
        altText: 'Unique Selection',
        url: selectionUrls.unique,
        desktopSize: 43,
        mobileSize: 43 * 0.65,
        svgSources: true
      };
    default:
      {
        return null;
      }
  }
};
var getCloudinarySrcSet = function getCloudinarySrcSet(format, imagePath, height, siteId, dpr) {
  var parameters = "/f_".concat(format, ",c_scale,h_").concat(height);
  var baseUrl = "".concat(cloudinaryBaseUrls[siteId]).concat(parameters);
  if (dpr) {
    return "".concat(baseUrl).concat(imagePath, ", ").concat(baseUrl, ",dpr_").concat(dpr).concat(imagePath, " ").concat(dpr, "x");
  }
  return "".concat(baseUrl).concat(imagePath);
};
var ConceptBadge = function ConceptBadge(_ref) {
  var _conceptSettings$altT;
  var className = _ref.className,
    _ref$siteId = _ref.siteId,
    siteId = _ref$siteId === void 0 ? 1 : _ref$siteId,
    concept = _ref.concept,
    onClick = _ref.onClick,
    alt = _ref.alt,
    lazy = _ref.lazy,
    rest = _objectWithoutProperties(_ref, _excluded);
  var checkedSiteId = getCheckedSiteId(siteId);
  var conceptSettings = getConceptSettings(concept, checkedSiteId);
  if (!concept || !conceptSettings) {
    return false;
  }
  var desktopHeight = conceptSettings.desktopSize || imageSizesDesktop.medium;
  var mobileHeight = conceptSettings.mobileSize || imageSizesMobile.medium;
  var getSources = function getSources() {
    var _conceptSettings$desk;
    var height = (_conceptSettings$desk = conceptSettings.desktopSize) !== null && _conceptSettings$desk !== void 0 ? _conceptSettings$desk : 'ih';
    if (conceptSettings.svgSources) {
      return [{
        srcSet: getCloudinarySrcSet('svg', conceptSettings.url, height, checkedSiteId),
        type: 'image/svg+xml'
      }, {
        srcSet: getCloudinarySrcSet('png', conceptSettings.url, height, checkedSiteId, '2.0'),
        type: 'image/png'
      }];
    }
    return [{
      srcSet: getCloudinarySrcSet('webp', conceptSettings.url, desktopHeight, checkedSiteId, '2.0'),
      type: 'image/webp',
      media: '(min-width: 768px)'
    }, {
      srcSet: getCloudinarySrcSet('jpg', conceptSettings.url, desktopHeight, checkedSiteId, '2.0'),
      type: 'image/jpeg',
      media: '(min-width: 768px)'
    }, {
      srcSet: getCloudinarySrcSet('webp', conceptSettings.mobileUrl, mobileHeight, checkedSiteId, '2.0'),
      type: 'image/webp'
    }, {
      srcSet: getCloudinarySrcSet('jpg', conceptSettings.mobileUrl, mobileHeight, checkedSiteId, '2.0'),
      type: 'image/jpeg'
    }];
  };
  var sources = getSources();
  var fallbackImgSrc = getCloudinarySrcSet('png', conceptSettings.url, desktopHeight, checkedSiteId);
  return /*#__PURE__*/jsx(ConceptBadge$2, _objectSpread(_objectSpread({
    className: className,
    onClick: onClick,
    concept: concept,
    desktopSize: conceptSettings.desktopSize,
    mobileSize: conceptSettings.mobileSize
  }, rest), {}, {
    children: /*#__PURE__*/jsx(Picture, {
      sources: sources,
      lazy: lazy,
      alt: (_conceptSettings$altT = conceptSettings.altText) !== null && _conceptSettings$altT !== void 0 ? _conceptSettings$altT : alt,
      fallbackSrc: fallbackImgSrc
    })
  }));
};
ConceptBadge.defaultProps = {
  className: null,
  alt: 'concept-logo',
  onClick: null,
  siteId: 1,
  lazy: false
};
var ConceptBadge$1 = ConceptBadge;

export { ConceptBadge$1 as default };
//# sourceMappingURL=ConceptBadge.js.map
